import { useRef } from "react";
import { ArticleCardGroup } from "../article-card-group"

const ThreeArticles = ({data}:{data: any}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const hits = data.map(x => {
        return {
            title: x.title,
            imageUrl: x.imageUrl,
            slug: x.slug,
            description: x.seoDescription
        }
    })
    return <ArticleCardGroup hits={hits} rowNumber={3} containerRef={containerRef} position={"relative"} />
}

export default ThreeArticles;